export default "__VITE_ASSET__Bz4RHhyp__"